import type { ReaderEvent } from './track';

type Subscriber = (event: ReaderEvent) => void;

const subscribers = new Set<Subscriber>();

/**
 * In-memory publish/subscribe for recorded events. Consumers (the analytics
 * dispatcher today) subscribe here. Returns an unsubscribe function.
 */
export function subscribe(subscriber: Subscriber): () => void {
	subscribers.add(subscriber);
	return () => {
		subscribers.delete(subscriber);
	};
}

/** A consumer throwing must never reach the code that recorded the event. */
export function publish(event: ReaderEvent): void {
	for (const subscriber of subscribers) {
		try {
			subscriber(event);
		} catch {
			// Swallowed deliberately: one consumer cannot break another, or the caller.
		}
	}
}
